module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ExtForm', {
    attrs: {
      "formData": _vm.form.data,
      "submitProxy": _vm.form.submitProxy,
      "submitBtnText": "Войти"
    },
    on: {
      "submitSuccess": _vm.login
    }
  }, [_c('b-form-fieldset', {
    class: {
      'is-invalid': _vm.errors.has('login')
    },
    attrs: {
      "label": "Логин",
      "feedback": _vm.errors.first('login')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim.lazy",
      value: (_vm.form.data.login),
      expression: "form.data.login",
      modifiers: {
        "trim": true,
        "lazy": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|eng'),
      expression: "'required|eng'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "login"
    },
    domProps: {
      "value": (_vm.form.data.login)
    },
    on: {
      "change": function($event) {
        _vm.form.data.login = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      'is-invalid': _vm.errors.has('password')
    },
    attrs: {
      "label": "Пароль",
      "feedback": _vm.errors.first('password')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim.lazy",
      value: (_vm.form.data.password),
      expression: "form.data.password",
      modifiers: {
        "trim": true,
        "lazy": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "password"
    },
    domProps: {
      "value": (_vm.form.data.password)
    },
    on: {
      "change": function($event) {
        _vm.form.data.password = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-833a591a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/forms/LoginForm.vue
// module id = 238
// module chunks = 1